import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  AppendLlmsTxtOptions,
  AppendLlmsTxtResponse,
  GetLlmsTxtOptions,
  GetLlmsTxtResponse,
  UpdateLlmsTxtHiddenStatusOptions,
  UpdateLlmsTxtHiddenStatusResponse,
  UpdateLlmsTxtOptions,
  UpdateLlmsTxtResponse,
  appendLlmsTxt as universalAppendLlmsTxt,
  getLlmsTxt as universalGetLlmsTxt,
  updateLlmsTxt as universalUpdateLlmsTxt,
  updateLlmsTxtHiddenStatus as universalUpdateLlmsTxtHiddenStatus,
} from './promote-seo-v2-llms-txt-llms-txt.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/seo' };

export function getLlmsTxt(httpClient: HttpClient): GetLlmsTxtSignature {
  return (options?: GetLlmsTxtOptions) =>
    universalGetLlmsTxt(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface GetLlmsTxtSignature {
  /**
   * Retrieves the `llms.txt` file entity.
   * @returns The response of the Llms.txt file request
   */
  (options?: GetLlmsTxtOptions): Promise<
    NonNullablePaths<
      GetLlmsTxtResponse,
      | `llmsTxt.content`
      | `llmsTxt.default`
      | `llmsTxt.subdomain`
      | `llmsTxt.manuallyEdited`
      | `llmsTxt.detectedLanguage`,
      3
    >
  >;
}

export function updateLlmsTxt(httpClient: HttpClient): UpdateLlmsTxtSignature {
  return (options?: UpdateLlmsTxtOptions) =>
    universalUpdateLlmsTxt(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface UpdateLlmsTxtSignature {
  /**
   * Updates the `llms.txt` file entity.
   *
   * The content can be set to an empty string to create a blank file.
   *
   * To restore Wix's default content, set the `default` field to `true` and omit the `content` field.
   */
  (options?: UpdateLlmsTxtOptions): Promise<
    NonNullablePaths<
      UpdateLlmsTxtResponse,
      | `llmsTxt.content`
      | `llmsTxt.default`
      | `llmsTxt.subdomain`
      | `llmsTxt.manuallyEdited`
      | `llmsTxt.detectedLanguage`,
      3
    >
  >;
}

export function appendLlmsTxt(httpClient: HttpClient): AppendLlmsTxtSignature {
  return (options?: AppendLlmsTxtOptions) =>
    universalAppendLlmsTxt(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface AppendLlmsTxtSignature {
  /**
   * Appends additional content to the existing `llms.txt` file.
   *
   * The provided content will be added to the end of the current file content.
   *
   * To reset to Wix's default content instead, set `default` to `true` and omit the `content` field.
   */
  (options?: AppendLlmsTxtOptions): Promise<
    NonNullablePaths<
      AppendLlmsTxtResponse,
      | `llmsTxt.content`
      | `llmsTxt.default`
      | `llmsTxt.subdomain`
      | `llmsTxt.manuallyEdited`
      | `llmsTxt.detectedLanguage`,
      3
    >
  >;
}

export function updateLlmsTxtHiddenStatus(
  httpClient: HttpClient
): UpdateLlmsTxtHiddenStatusSignature {
  return (options?: UpdateLlmsTxtHiddenStatusOptions) =>
    universalUpdateLlmsTxtHiddenStatus(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface UpdateLlmsTxtHiddenStatusSignature {
  /**
   * Updates only the hidden state of the Llms.txt file.
   * Content remains unchanged - only visibility is modified.
   * @returns The response of updating the hidden state of Llms.txt file
   */
  (options?: UpdateLlmsTxtHiddenStatusOptions): Promise<
    NonNullablePaths<
      UpdateLlmsTxtHiddenStatusResponse,
      | `llmsTxt.content`
      | `llmsTxt.default`
      | `llmsTxt.subdomain`
      | `llmsTxt.manuallyEdited`
      | `llmsTxt.detectedLanguage`,
      3
    >
  >;
}

export {
  AccountInfo,
  ActionEvent,
  AppendLlmsTxtOptions,
  AppendLlmsTxtRequest,
  AppendLlmsTxtResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  EntityDeletedEvent,
  EntityUpdatedEvent,
  GetLlmsTxtOptions,
  GetLlmsTxtRequest,
  GetLlmsTxtResponse,
  IdentificationData,
  IdentificationDataIdOneOf,
  LlmsTxt,
  MessageEnvelope,
  RestoreInfo,
  UpdateLlmsTxtHiddenStatusOptions,
  UpdateLlmsTxtHiddenStatusRequest,
  UpdateLlmsTxtHiddenStatusResponse,
  UpdateLlmsTxtManuallyEditedStatusRequest,
  UpdateLlmsTxtManuallyEditedStatusResponse,
  UpdateLlmsTxtOptions,
  UpdateLlmsTxtRequest,
  UpdateLlmsTxtResponse,
  WebhookIdentityType,
} from './promote-seo-v2-llms-txt-llms-txt.universal.js';
